import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DatabaseService } from 'src/app/_services/database.service';
import { Router } from '@angular/router';
import {Validators,FormGroup,FormBuilder} from '@angular/forms';
import { SnackBarOverview } from 'src/app/Toast';
@Component({
  selector: 'app-import-invoice',
  templateUrl: './import-invoice.component.html'
})
export class ImportinvoiceComponent implements OnInit {

  ImportForm: FormGroup;
  constructor(private formBuilder: FormBuilder ,public db:DatabaseService,public router:Router,public toast: SnackBarOverview) {
  }

  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('policyNum') policyNum!: ElementRef;

  day:any='';
  month:any='';
  year:any='';
  uploadurl:any='';
  ngOnInit() {
    this.uploadurl = this.db.UploadUrl;
    
    let date = new Date();
    this.day = date.getDate();
    this.month = date.getMonth();
    this.year = date.getFullYear();
    // this.ImportForm = this.formBuilder.group({
    //   name: ['', Validators.required],
    // });
  }
  
  // get e() { return this.ImportForm.controls; }
  
  download_invoice()
  {
    window.open(this.db.UploadUrl+'/invoice.csv','__self');
  }
  download_item()
  {
    window.open(this.db.UploadUrl+'/invoice_item.csv','__self');
  }

  uploading: boolean = false;
  uploadFile()
  {
    let files: FileList = this.fileInput.nativeElement.files;
    let policy_num: string = this.policyNum.nativeElement.value;

    if (!files || files.length === 0)
    {
      this.toast.openError('Please select file(s) to upload', '');
      return;
    }
    if (!policy_num)
    {
      this.toast.openError('Please enter policy number', '');
      return;
    }

    let formData = new FormData();
    for (let i = 0; i < files.length; i++)
    {
      formData.append('upload[]', files[i], files[i].name);
    }
    formData.append('policy_num', policy_num);

    this.uploading = true;
    this.db.ImportInvoiceData(formData)
    .subscribe((result: any) =>
    {
      this.uploading = false;
      console.log(result);
      if (result && result['message'] == 'Success')
      {
        this.toast.openSucess('Invoice Imported Successfully', '');
        this.fileInput.nativeElement.value = '';
        this.policyNum.nativeElement.value = '';
      }
      else
      {
        this.toast.openError((result && result['message']) || 'Import failed', '');
      }
    }, (error: any) =>
    {
      this.uploading = false;
      console.log(error);
      this.toast.openError('Something went wrong while importing invoice', '');
    });
  }

}